import StartExtendPayment from "@/types/clients/esquire/requests/payment/start-extend-payment";
import GetPaymentMethods from "@/types/clients/esquire/requests/payment/get-payment-methods";
import PostPaymentData, {IContractUpdatePartial} from "@/types/clients/esquire/requests/payment/post-payment-data";
import esquireClient from "@/types/clients/esquire";
import GetPaymentMethodsByBuildingId from "@/types/clients/esquire/requests/payment/get-payment-methods-by-building-id";
import GetPaymentInfoResponseBody from "@/types/clients/esquire/data/payment/get-payment-info-response-body";
import Contract from "@/types/clients/esquire/data/general/contract";
import OptionData from "@/types/clients/esquire/data/general/contract-data/option";
import StartReservationPayment from "@/types/clients/esquire/requests/payment/start-reservation-payment";
import {PaymentRequest} from "@/interfaces/esquire/payment-request";
import useStore from "@/stores";

const startReservationPaymentRequest = new StartReservationPayment(esquireClient);
const startExtendPaymentRequest = new StartExtendPayment(esquireClient);
const getPaymentMethodsRequest = new GetPaymentMethods(esquireClient);

export class PaymentService {

  static generateContractUpdates(contracts: Contract[]): IContractUpdatePartial[] {
    return contracts.map((c: Contract) => ({
      contract_id: c.id,
      new_options: c.getAddedOptions().map((o: OptionData) => ({
        option_id: o.id,
        selected_dates: o.selectedDates ?? []
      })),
      removed_options: c.getRemovedOptions().map((o: OptionData) => ({
        option_id: o.id,
        selected_dates: []
      }))
    }));
  }

  static async fetchPaymentMethods(buildingId: string|null = null) {
    if (buildingId) {
      const request = new GetPaymentMethodsByBuildingId(esquireClient, buildingId);
      return await request.send();
    }
    return await getPaymentMethodsRequest.send();
  }

  static redirectToPayment(paymentInfo: GetPaymentInfoResponseBody): void {
    const {session} = useStore();
    session.guid = paymentInfo.guid;
    window.location.href = paymentInfo.initiateUrl;
  }

  static async startReservationPayment(
    reservationId: string,
    selectedMethod: string,
    returnUrl: string,
    contracts: Array<Contract>
  ): Promise<GetPaymentInfoResponseBody> {
    return this._startPayment(
      reservationId,
      selectedMethod,
      returnUrl,
      contracts,
      startReservationPaymentRequest
    );
  }

  static async startExtendPayment(
    reservationId: string,
    selectedMethod: string,
    returnUrl: string,
    contracts: Array<Contract>
  ): Promise<GetPaymentInfoResponseBody> {
    return this._startPayment(
      reservationId,
      selectedMethod,
      returnUrl,
      contracts,
      startExtendPaymentRequest
    );
  }

  private static async _startPayment(
    reservationId: string,
    selectedMethod: string,
    returnUrl: string,
    contracts: Array<Contract>,
    request: PaymentRequest
  ): Promise<GetPaymentInfoResponseBody> {

    const contractUpdates = this.generateContractUpdates(contracts);

    const postPayment = new PostPaymentData({
      reservationId,
      paymentMethod: selectedMethod,
      returnUrl,
      contractUpdates
    });

    const paymentInfo = await request.send(postPayment);

    this.redirectToPayment(paymentInfo);

    return paymentInfo;
  }

}
export default PaymentService;
